import React, { useState } from 'react';
import clsx from 'clsx';
import { Button } from 'antd';
import { ExportConfigurationModal } from './ExportConfigurationModal';
import styles from './AlertResultExport.module.less';

type AlertResultExportProps = {
  className?: string;
  alertId: string | null;
  sourceOwnerId: string | null;
  insertionDate: string | null;
};

export const AlertResultExport: React.FC<AlertResultExportProps> = ({
  className,
  alertId,
  sourceOwnerId,
  insertionDate,
}) => {
  const [exportModalVisible, setExportModalVisible] = useState<boolean>(false);
  const isExportEnabled = !!(alertId && sourceOwnerId && insertionDate);
  const showExportModal = () => setExportModalVisible(true);
  const hideExportModal = () => setExportModalVisible(false);

  return (
    <div className={clsx(className)}>
      <Button type="primary" onClick={showExportModal} disabled={!isExportEnabled}>
        Export
      </Button>
      {isExportEnabled && (
        <ExportConfigurationModal
          className={styles.exportModal}
          visible={exportModalVisible}
          alertId={alertId}
          sourceOwnerId={sourceOwnerId}
          insertionDate={insertionDate}
          closeModal={hideExportModal}
        />
      )}
    </div>
  );
};
